import { common } from "./common.service"

export const albumService = {
    get,
    getList,
    put,
    getFiles,
    deleteAlbum,
    uploadFile,
    deleteFile,
    setAlbumCover,
    changePrivacy,
    changeUser,
    incrementSize,
    orderFiles
}

/**
 * Get list of all files of an album
 * @param {*} id 
 * @param {*} fingerprint 
 * @returns 
 */
async function getFiles(id) {
    let url = `files/${id}`;
    const userIsLogged = !!localStorage.getItem('token');
    if (userIsLogged) {
        return common.fetchAPI({ url, method: "GET", token: true });
    } else {
        return common.fetchAPI({ url, method: "GET" });
    }
}

/**
 * Get all informations of an album
 * @param {*} id 
 * @returns 
 */
async function get(id) {
    let url = `album/${id}`;
    const userIsLogged = !!localStorage.getItem('token');
    if (userIsLogged) {
        return common.fetchAPI({ url, method: "GET", token: true });
    } else
        return common.fetchAPI({ url, method: "GET" });
}

/**
 * Update an album
 * @param {*} id
 * @param {*} data
 * @returns 
 */
async function put(id, data) {
    let url = `album/${id}`;
    return common.fetchAPI({ url, method: "PUT", data, token: true });
}

/**
 * Get list of all albums
 * @returns 
 */
async function getList() {
    let url = `album`;
    return common.fetchAPI({ url, method: "GET", token: true });
}

/**
 * Delete an album
 * @param {*} id 
 * @param {*} password 
 * @returns 
 */
async function deleteAlbum(id, password) {
    let url = `album/${id}`;
    return common.fetchAPI({ url, method: "DELETE", data: { password }, token: true });
}

/**
 * Upload files
 */
async function uploadFile(data) {
    let url = `file`;
    const userIsLogged = !!localStorage.getItem('token');
    return common.fetchAPI({ url, method: "POST", data, useStringify: false, token: userIsLogged });
}

async function deleteFile(id) {
    let url = `file/${id}`;
    return common.fetchAPI({ url, method: "DELETE", token: true });
}

async function setAlbumCover(idAlbum, idFile) {
    let url = `album/${idAlbum}/cover`;
    return common.fetchAPI({ url, method: "PUT", data: { file_id: idFile }, token: true });
}

async function changePrivacy(idAlbum, privacy) {
    let url = `album/${idAlbum}/privacy`;
    return common.fetchAPI({ url, method: "PUT", data: { privacy }, token: true });
}

async function changeUser(idAlbum, email, password) {
    let url = `album/${idAlbum}/change-user`;
    return common.fetchAPI({ url, method: "PUT", data: { newUserEmail: email, password }, token: true });
}

async function incrementSize(idAlbum, option) {
    let url = `album/${idAlbum}/increment-size?option=${option}`;
    return common.fetchAPI({ url, method: "PUT", token: true });
}

async function orderFiles(idAlbum, ids) {
    let url = `album/${idAlbum}/order-files`;
    return common.fetchAPI({ url, method: "PUT", data: { 
        file_ids: ids
     }, token: true });
}